import styled from 'styled-components';

export const RemoveContainer = styled.div`
  justify-content: center;
  display: flex;
  align-items: center;
`;

export default RemoveContainer;
